
const env = process.env.VUE_APP_ENV
let Gtag_ID = ''

if (env === 'prod' || env === 'production') {
  Gtag_ID = 'G-67DYWSMGNR'
} else {
  Gtag_ID = 'G-GV3X51J91Y'
}

var new_element = document.createElement('script')
new_element.setAttribute('type', 'text/javascript')
new_element.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + Gtag_ID)

document.body.appendChild(new_element)

window.onload = function() {
  window.dataLayer = window.dataLayer || []
  function gtag() { dataLayer.push(arguments) }
  gtag('js', new Date())

  gtag('config', Gtag_ID, { 'send_page_view': false })

  window.gtag = gtag
}
